export class IdentifierUtils {
  /**
   * check for identifier
   * @returns translationKey for the given identifier
   */
  static abbreviateOtherArticleIdentifier(identifier: string): string {
    let statement = '';
    switch (identifier) {
      case '66298': {
        statement = 'identifierUtils.GTIN';
        break;
      }
      case '66299': {
        statement = 'identifierUtils.EAN';
        break;
      }
      case '66300': {
        statement = 'identifierUtils.GPC';
        break;
      }
      case '66301': {
        statement = 'identifierUtils.JAN';
        break;
      }
      case '66302': {
        statement = 'identifierUtils.UDI';
        break;
      }
      case '66303': {
        statement = 'identifierUtils.ISBN';
        break;
      }
      case '66304': {
        statement = 'identifierUtils.catalogueNumber';
        break;
      }
      case '66305': {
        statement = 'identifierUtils.batchNumber';
        break;
      }
      case '66306': {
        statement = 'identifierUtils.partNumber';
        break;
      }
      case '66307': {
        statement = 'identifierUtils.itemNumber';
        break;
      }
      case '66308': {
        statement = 'identifierUtils.referenceNumber';
        break;
      }
      case '66309': {
        statement = 'identifierUtils.serialNumber';
        break;
      }
      case '1342': {
        statement = 'identifierUtils.other';
        break;
      }
      default: {
        statement = identifier;
        break;
      }
    }

    return statement;
  }
}
